import { toast } from 'sonner';
import { api } from '@/lib/api';

export const adsApi = '/ads';
export const errorText = (e) => typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Une erreur est survenue. Réessayez.';
export const canEdit = (user) => ['super_admin', 'manager', 'collaborator'].includes(user?.role);
export const inFlight = (s) => ['queued', 'writing', 'rendering'].includes(s);
export const statusLabel = { queued: 'En file', writing: 'Rédaction IA', rendering: 'Rendu image', done: 'Prête', failed: 'Échec' };
export const projectStatus = { briefing: 'Brief en cours', ready: 'Prêt', brief_failed: 'Brief échoué' };
export const dateLabel = (v) => v ? new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(v)) : '';
export const imgSrc = (url) => url?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
export const scoreTone = (s) => s >= 75 ? 'high' : s >= 55 ? 'mid' : 'low';

export async function downloadBlob(request, fallback) {
  try {
    const r = await request();
    const name = r.headers['content-disposition']?.match(/filename="([^"]+)"/)?.[1] || fallback;
    const url = URL.createObjectURL(r.data); const a = document.createElement('a'); a.href = url; a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(url), 1500);
  } catch (e) {
    if (e.response?.data instanceof Blob) { try { e.response.data = JSON.parse(await e.response.data.text()); } catch { /* ignore */ } }
    throw e;
  }
}
export const downloadCreative = (id, format) => downloadBlob(() => api.get(`${adsApi}/creatives/${id}/download`, { params: format ? { format } : {}, responseType: 'blob', timeout: 120000 }), 'creative.jpg');
export const downloadPack = (pid, ids, format) => downloadBlob(() => api.post(`${adsApi}/projects/${pid}/export`, { ids, format }, { responseType: 'blob', timeout: 300000 }), 'ads-pack.zip');
export const copyText = async (text, label = 'Copié') => {
  const value = text || '';
  try { await navigator.clipboard.writeText(value); toast.success(label); return true; } catch { /* fallback below */ }
  try {
    const ta = document.createElement('textarea'); ta.value = value; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
    const ok = document.execCommand('copy'); document.body.removeChild(ta);
    if (ok) { toast.success(label); return true; }
  } catch { /* ignore */ }
  toast.error('Copie indisponible dans ce navigateur'); return false;
};
